import { TRootState } from 'store/store';

export const getPlayer = (state: TRootState) => state.player;
